import { render, staticRenderFns } from "./systemItems.vue?vue&type=template&id=23285a5b"
import script from "./systemItems.vue?vue&type=script&lang=js"
export * from "./systemItems.vue?vue&type=script&lang=js"
import style0 from "./systemItems.vue?vue&type=style&index=0&id=23285a5b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports